<template>
  <div class="index_content">
    <!-- 搜索 -->
    <div class="index_head">
      <el-form
        class="el-form1"
        ref="searchForm"
        :model="searchForm"
        label-width="60rem"
        :inline="true"
      >
        <div>
          <el-form-item label="地区:" prop="areaId">
            <el-cascader
              :options="options"
              popper-class="sel-area-cascader"
              v-model="searchForm.areaId"
              style="width: 220rem"
              clearable
              :props="{ expandTrigger: 'hover' }"
              @change="handleChange"
              placeholder="全部"
            >
            </el-cascader>
          </el-form-item>
          <el-form-item label="题源:" prop="bookType">
            <el-cascader
              :options="questionOptions"
              popper-class="sel-area-cascader"
              v-model="searchForm.bookType"
              style="width: 220rem"
              clearable
              :props="{ expandTrigger: 'hover' }"
              @change="handleChange"
              placeholder="全部"
            >
            </el-cascader>
          </el-form-item>
          <el-form-item label="年份:" prop="year">
            <el-date-picker
              v-model="searchForm.year"
              type="year"
              size="small"
              style="width: 130rem"
              popper-class="left_year"
              class="custom-date-picker-selection"
              value-format="yyyy"
              :picker-options="pickerOptions"
              placeholder="全部"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="模块:" prop="catalogType">
            <el-select
              v-model="searchForm.catalogType"
              style="width: 220rem"
              placeholder="全部"
              @change="distrcitChange"
              popper-class="select-popper"
              clearable
            >
              <el-option
                v-for="item in districtList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button plain @click="search" class="btn_1">搜索</el-button>
          </el-form-item>
          <el-form-item>
            <el-button plain @click="resetSearchForm" class="btn_2"
              >重置</el-button
            >
          </el-form-item>
        </div>
        <div>
          <el-form-item>
            <el-button
              icon="el-icon-circle-plus-outline"
              plain
              @click="
                dialogTitle = '创建地区';
                dialogVisible = true;
              "
              class="btn_3"
              >创建地区</el-button
            >
          </el-form-item>
        </div>
      </el-form>
    </div>

    <!-- 各省市试题 -->
    <div class="index_body">
      <questionItem
        v-for="(item, index) in questionItemList"
        :bookItemObj="item"
        :gradeList="gradeList"
        :versionList="versionList"
        @enableDistrict="enableDistrict($event, item)"
        @editDistrict="editDistrict"
        @delRegion="delRegion"
        @initData="init"
        @refreshFlagToFalse="refreshFlagToFalse"
        :refreshFlag="refreshFlag"
        :option="questionOptions"
        :key="index"
        class="questionItem"
      ></questionItem>
      <el-empty
        description=" "
        :image-size="300"
        :image="require('./static/empty.png')"
        v-if="isEmpty"
        class="empty_img"
      ></el-empty>
    </div>
    <!-- 创建地区-->
    <div class="index_dia">
      <el-dialog
        :visible.sync="dialogVisible"
        ref="dialog"
        width="460rem"
        :before-close="closeDialog"
      >

        <div slot="title" class="dia-title">
          <div class="dia-title-content">
              <div class="dia-title-before"></div>
              <div class="dia-title-text">{{dialogTitle}}</div>
          </div>
        </div>

        <div class="dia_item">
          <el-form
            :model="districtForm"
            :rules="rules"
            ref="districtForm"
            label-width="60rem"
          >
            <el-form-item prop="areaId" class="area" label="地区:">
              <!-- <div class="dia_item_distrit" style="font-size:14rem">地区:</div> -->
              <el-cascader
                :options="filterArr"
                popper-class="sel-area-cascader"
                v-model="districtForm.areaId"
                clearable
                :props="{ expandTrigger: 'hover' }"
                placeholder="请选择地区"
              >
              </el-cascader>
            </el-form-item>
            <el-form-item  prop="status" label="启用:">
              <!-- <div class="dia_item_enable" style="font-size:14rem">启用:</div> -->
              <el-switch
                v-model="districtForm.status"
                active-color="#0BAE6A"
                inactive-color="#eeeeee"
                style="margin-top:10px"
              >
              </el-switch>
            </el-form-item>
          </el-form>
          <el-button
            :disabled="btnDisabled"
            plain
            size="mini"
            @click="save"
            :class="{ saveBtn: btnDisabled }"
            ><p style="font-size:14rem">确定</p></el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
    import questionItem from './components/questionItem'
    import {getDistrict, getQuestionSource, addOrEditDistrict, searchQuestion, updateDistrictStatus, deleteRegion, getAllModule, getModuleData, getGradeAndVersion} from '@/api/questionIndex'
    import {questionOptions} from '@/constants/constants'
    import _ from 'lodash'
    
    export default {
        name: 'districtIndex',
        components: {
            questionItem,
        },
        watch:{
            districtForm:{
                handler(val){
                    if(val.areaId.length > 0){
                        this.btnDisabled = false
                    }else{
                        this.btnDisabled = true
                    }
   
                },
                deep:true,
                immediate:true
            }
        },
        mounted(){
            //获取地区列表
             this.init()
            // 获取年级和版本数据
             this.getGradeAndVersionData()
        
        },
        data() {
            return {
                options:[],
                filterArr:[],
                questionOptions:[],
                questionItemList:[],
                dialogVisible: false,
                btnDisabled:true,
                dialogTitle: '',
                refreshFlag:false,
                isEmpty:false,
                pickerOptions:{
                    disabledDate:(time)=>{
                        let year = time.getFullYear()
                        let dataRange = [2024,2025,2026,2027,2028,2029,2030]
                        return !dataRange.includes(year)
                    }
                },
                districtList: [
                    {id: '听说模拟训练', name: '听说模拟训练'},
                    {id: '题型专项训练', name: '题型专项训练'} 
                ],
                searchForm: {
                    areaId: 0,
                    bookType: 0,
                    year: '',
                    catalogType: ''
                },
                districtForm: {
                    areaId: 0,
                    status:true
                },
                rules:{
                    areaId:[{ required: true, message: '请选择地区', trigger: 'blur' }]
                },
                gradeList: [], // 新增题源中的年级列表
                versionList: [] // 新增题源中的册别列表
            }
        },
        methods: {
            // 获取题源选项
            getQuestionOptions(){
                return this.questionOptions
            },
            init(){
                //获取地区列表
                this.getDistrict()
                //获取试题来源
                this.getQuestionSource()
                //获取试题列表
                this.search()
                //获取全部模块列表
                this.getModule()
                //获取下拉框模块列表
                this.getModuleInfo();
            },
            getModuleInfo(){
              getModuleData().then(res => {
                if(res.code == 0){
                  let arr = [];
                  res.data.some((item)=>{
                    arr.push({"id":item,"name":item});
                  })
                  console.log(res)
                  this.districtList = arr;
                }
              })
            },
            getModule(){
              getAllModule().then(res => {
                if(res.code == 0){
                  sessionStorage.setItem('moduleData',JSON.stringify(res.data));
                }
              })
            },
            getDistrict(){
                getDistrict().then(res => {
                    this.options = this.getCascaderList(res);
                    this.filterOptions(this.options)
                    questionOptions.options = this.options;
                })
            },
            
            filterOptions(options){
              if(options.length > 0){
                  this.filterArr = _.cloneDeep(options)
                  this.filterArr.forEach(item => {
                    if(item.children){
                      _.remove(item.children, function(n){
                        return n.label == '全部'
                      })
                    }
                  })
              }
            },

            search(){
                this.convertFormData(this.searchForm)
                searchQuestion(this.searchForm).then(res => {
                    if(res.code == 0){
                        this.questionItemList = res.data
                        this.refreshFlag = true
                        this.isEmpty = false
                        if(res.data.length == 0){
                            this.isEmpty = true
                        }
                    }else{
                        this.$message.error(res.info)
                    }
                })
            },
            convertFormData(form){
                if(Array.isArray(form.areaId)){
                    if(form.areaId.length > 0){
                        form.areaId = form.areaId[form.areaId.length - 1]
                    }else{
                        form.areaId = 0
                    }
                }
                if(Array.isArray(form.bookType)){
                    if(form.bookType.length > 0){
                        form.bookType = form.bookType[form.bookType.length - 1]
                    }else{
                        form.bookType = 0
                    }
                }
            },

            getQuestionSource(){
                getQuestionSource().then(res => {
                    this.questionOptions = this.getCascaderList(res);
                    questionOptions.questionOptions = this.questionOptions;
                })
            },
            getCascaderList(res){
                let sourceOption = []
                if(res.code == 0 && res.data.length > 0){
                    let resData = res.data
                    resData.forEach(item => {
                        let optionItem = {
                            value:item.id,
                            label:item.name
                        }
                        if(item.children.length > 0){
                            let cityItems = []
                            if(item.name == "广东"){
                                cityItems.push({
                                    value:4400000,
                                    label:'全部'
                                })
                            }else if(item.name == "山东"){
                                cityItems.push({
                                    value:3700000,
                                    label:'全部'
                                })
                            }
                            item.children.forEach(child => {
                                let cityItemObj= {
                                    value:child.id,
                                    label:child.name
                                }
                                if(child.children.length > 0){
                                    let  zoneItems = []
                                    child.children.forEach(childs => {
                                        let zoneItemsObj = {
                                            value:childs.id,
                                            label:childs.name
                                        }
                                        zoneItems.push(zoneItemsObj)
                                    })
                                    cityItemObj.children = zoneItems
                                }
                                cityItems.push(cityItemObj)
                            })
                            optionItem.children = cityItems
                        }
                        sourceOption.push(optionItem)
                        
                    })
                }
                return sourceOption
            },
            distrcitChange() {
                // console.log(val)
            },
            resetSearchForm(){
                this.resetForm('searchForm')
                this.search()
                this.$message.success('重置成功')
            },
            closeDialog() {
                this.dialogVisible = false
                this.resetDistrictForm()
            },
            enableDistrict(e,item){
                let word = e=='0'?'启用成功':'禁用成功'
                updateDistrictStatus({id:item.id, status:e}).then(res => {
                    if(res.code == 0){
                        this.$message.success(word)
                        this.init()
                    }else{
                        this.$message.error(res.info)
                    }
                })
            },
            editDistrict(e){
                this.dialogTitle = '编辑地区'
                this.dialogVisible = true
                this.districtForm.areaId = e.areaIdNodes
                this.districtForm.status = e.status == '0' ? true : false
                this.districtForm.id = e.id
            },
            save(){
                let form = {}
                //select下拉组件是一个索引数组，保存取最后一个值
                form.areaId = this.districtForm.areaId[this.districtForm.areaId.length - 1]
                form.status = this.districtForm.status ? '0' : '1'
                if(this.districtForm.id){
                    form.id = this.districtForm.id
                }
                addOrEditDistrict(form).then(res => {
                    let msg = this.dialogTitle == '编辑地区'?'修改成功':'保存成功'
                    if(res.code == 0){
                        this.$message.success(msg)
                        this.resetDistrictForm()
                        this.dialogVisible = false
                        this.resetForm('searchForm')
                        this.init()
                    }else{
                        this.$message.error(res.info)
                    }
                })
            },
            delRegion(data){
              deleteRegion({"regionId":data.id}).then(res => {
                  if(res.code == 0){
                      this.$message.success("删除地区成功")
                      this.resetDistrictForm()
                      this.dialogVisible = false
                      this.resetForm('searchForm')
                      this.init()
                  }else{
                      this.$message.error(res.info)
                  }
              })
            },
            resetForm(formName){
                this.$refs[formName].resetFields()
            },
            resetDistrictForm(){
                this.districtForm = {
                    areaId: 0,
                    status:true
                }
            },
            handleChange(){
            //    console.log(val)
            },
            refreshFlagToFalse(){
                this.refreshFlag =false
            },
            getGradeAndVersionData(){
              getGradeAndVersion().then(res => {
                  if(res.code == 0) {
                    const rawData = JSON.parse(res.data)
                    console.log("🐞 - district.vue:477 - getGradeAndVersionData :", rawData)
                    this.gradeList = rawData.grade||[]
                    this.versionList = rawData.version||[]
                  }
              })
            }
        }
    }
</script>
<style lang="scss" scoped>
    .index_content {
        margin: auto;
        width: 100%;
        height: 90vh;
        border-radius: 12rem;
        background: #fff;
        .questionItem {
            margin: 10rem 0rem 20rem 20rem;
        }
    .index_head {
      box-sizing: border-box;
      padding: 20rem 10rem 0rem 10rem;
      width: 100%;
    .el-form1 {
      display: flex;
      align-items: center;
      justify-content: space-between;
      // font-size: 14rem;
      .btn_1,
      .btn_2 {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        width: 68rem;
        height: 32rem;
        color: #fff;
        font-size: 14rem;
      }
      .btn_3 {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        width: 110rem;
        height: 32rem;
        color: #fff;
        font-size: 14rem;
      }
      .btn_1,
      .btn_3 {
        background-image: var(--background-image);
        border-color: var(--primary-color);
        // outline: 0;
      }
      .btn_2 {
        border-color: var(--primary-color);
      }
      .btn_2 {
        background: #fff!important;
        color: var(--primary-color);;
      }
    }
    .el-form .el-button:nth-child(1) {
      background-image: var(--background-image);
    }
  }
  .index_body {
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-around;
    position: relative;
    overflow-y: scroll;
    overflow-x: hidden;
    height: 88%;
    .empty_img {
      position: absolute;
      top: 26%;
      left: 40%;
    }
  }

  .index_dia {
    border-radius: 4rem;
    ::v-deep .el-form-item__content{
      width: 250rem;
      display: flex;
      align-items: center;
      line-height: 40rem
      
    }
    ::v-deep .el-input__icon{
      line-height: 40rem;
    }
    .dia_item_distrit, .dia_item_enable{
      width:60rem;
    }
    .el-cascader{
      width:180rem
    }
    .dia_item {
      margin: auto;
      width: 400rem;

      .saveBtn {
        background: #b7e7d3;
      }


    }
  }
  .dia-title-content{
    display: flex;
    align-items: center;
    line-height: 14rem;
    width: 100rem;
    justify-content: space-between;
    .dia-title-before{
      width:6rem;
      height: 14rem;
      border-radius: 3rem;
      background: var(--primary-color);
    }
    .dia-title-text{
      width: 90rem;
    }
    font-size: 14rem;
  }
  
  ::v-deep .el-dialog {
    border-radius: 10rem;
    // height: 351rem;
    background: #f5f5f5;
  }
  ::v-deep .el-dialog__header{
    width: 88%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20rem 20rem 10rem 30rem;
  }
  ::v-deep .el-dialog__headerbtn{
    position: static;
    font-size: 20rem;
  }
  ::v-deep .el-dialog__title {
    padding-left: 26rem;
    line-height: 24rem;
    font-size: 14rem;
    &:before {
      content: "";
      position: absolute;
      left: 30rem;
      top: 32rem;
      width: 5rem;
      height: 20rem;
      border-radius: 10rem;
      background-color: var(--primary-color);
    }
  }
  .el-dialog {
    .el-form {
      height: 183rem;
      background: #fff;
      margin: 0 auto;
      padding: 20rem;
      border-radius: 6rem;
    }
    .el-button {
      float: right;
      width: 76rem;
      height: 32rem;
      position: relative;
      top: 15rem;
      font-size: 16rem;
      color: #fff;
      background: var(--primary-color);
      border: none !important;
    }
  }

  ::v-deep .el-dialog {
    display: flex;
    flex-direction: column;
    margin: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
::v-deep .el-input__inner {
  height: 32rem;
  font-size: 14rem;
  line-height: 40rem;
}
::v-deep .el-form-item {
  margin-bottom: 20rem;
}
.el-form--inline .el-form-item{
vertical-align: middle;
}
::v-deep .el-form-item__label {
  white-space: nowrap;
  font-size: 14rem;
}
::v-deep .el-dialog__body {
  padding: 10rem 20rem 20rem 20rem;
}
::v-deep .el-dialog__header .el-dialog__close:hover {
  color: var(--primary-color) !important;
}
::v-deep .el-input__inner:hover,
::v-deep .el-input__inner:focus {
  border-color: var(--primary-color);
}
::v-deep .el-cascader .el-input.is-focus .el-input__inner {
  border-color: var(--primary-color);
}
::v-deep .el-cascader .el-input .el-input__inner:focus,
::v-deep .el-select .el-input .el-input__inner:focus,
::v-deep .el-cascader .el-input .el-input__inner:hover,
::v-deep .el-select .el-input .el-input__inner:hover {
  border-color: var(--primary-color);
}

::-webkit-scrollbar {
  width: 8rem;
}
::-webkit-scrollbar-thumb {
  border-radius: 6rem;
  background-color: #d9d9d9;
}

::-webkit-scrollbar-track {
  background-color: #fff;
  margin-right: 10rem;
}
::v-deep span .el-form-item__content{
  width: 140px !important;
  height: 20rem;
}
</style>
<style lang="scss">
.sel-area-cascader {
  .el-cascader-node.in-active-path,
  .el-cascader-node.is-active,
  .el-cascader-node.is-selectable.in-checked-path {
    color: #0bae6a;
  }
}
.select-popper {
  .el-select-dropdown__item.selected,
  .el-select-dropdown__item.hover {
    color: var(--primary-color);
  }
}
</style>